import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output
} from '@angular/core';

@Component({
  selector: 'app-mass-os-stepper',
  templateUrl: './mass-os-stepper.component.html',
  styleUrls: ['./mass-os-stepper.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MassOsStepperComponent {
  @Input() steps: string[] = [];
  @Input() activeIndex = 0;

  @Output() stepSelect = new EventEmitter<number>();

  select(index: number): void {
    if (index > this.activeIndex) {
      return;
    }
    this.stepSelect.emit(index);
  }
}
